module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "r-container",
    class: {
      'is-loading': _vm.isLoading
    }
  }, [(_vm.isLoading) ? _c('relatorio-loading') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "content-transition relatorio-print",
    attrs: {
      "id": "container-printer"
    }
  }, [_c('div', {
    staticClass: "hidden-print"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFiltros),
      expression: "showFiltros"
    }],
    staticClass: "r-table"
  }, [_c('div', {
    staticClass: "r-table-content"
  }, [_c('div', {
    staticClass: "m-t"
  }, [_c('div', {
    staticClass: "m-b"
  }, [_c('div', [_vm._v("Tipo de Venda:")]), _vm._v(" "), _c('u-button-group', {
    attrs: {
      "options": _vm.tiposLeilao
    },
    model: {
      value: (_vm.filtro.tipo),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "tipo", $$v)
      },
      expression: "filtro.tipo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_c('div', [_vm._v("Situação:")]), _vm._v(" "), _c('u-button-group', {
    attrs: {
      "multiSelect": true,
      "options": _vm.situacaoLote
    },
    model: {
      value: (_vm.filtro.situacao),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "situacao", $$v)
      },
      expression: "filtro.situacao"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-b"
  }, [_vm._v("\n                Resultados: " + _vm._s(_vm.vendas && _vm.vendas.length) + "\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-print"
  }, [_c('h2', {
    staticClass: "text-center text-uppercase font-bold m-b-none"
  }, [_vm._v("Relatório de Venda por Arrematante")]), _vm._v(" "), _c('h4', {
    staticClass: "text-center text-uppercase"
  }, [_vm._v("Leilão Realizado " + _vm._s(_vm.moment(_vm.leilao.dataAbertura.date).format('LLLL')))])]), _vm._v(" "), _vm._l((_vm.vendas), function(venda, key) {
    return _c('div', {
      staticClass: "printer-page pos-rlt"
    }, [_c('div', {
      staticClass: "visible-print"
    }, [_c('h2', {
      staticClass: "text-center text-uppercase font-bold m-b-none"
    }, [_vm._v("Relatório de Saída de Bens")]), _vm._v(" "), _c('h4', {
      staticClass: "text-center text-uppercase"
    }, [_vm._v("Leilão Realizado " + _vm._s(_vm.moment(_vm.leilao.dataAbertura.date).format('LLLL')))])]), _vm._v(" "), _c('div', {
      staticClass: "r-table"
    }, [_c('div', {
      staticClass: "r-table-header"
    }, [_c('div', {
      staticClass: "pull-left font-bold text-black"
    }, [_vm._v(_vm._s(venda.arrematante.apelido) + " - " + _vm._s(venda.arrematante.pessoa.nome))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "r-table-content"
    }, [_c('div', {
      staticClass: "m-t"
    }, [_c('table', {
      staticClass: "w-full table table-bordered m-b-none"
    }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Arrematante")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(venda.arrematante.pessoa.nome) + "\n                    (" + _vm._s(venda.arrematante.apelido) + ") #A" + _vm._s(venda.arrematante.id) + "-P" + _vm._s(venda.arrematante.pessoa.id) + "\n\n                    ")])]), _vm._v(" "), (venda.arrematante.pessoa.tipo === 1) ? _c('tr', [_c('td', [_vm._v("Tratamento")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(venda.arrematante.pessoa.pfTratamento))]), _vm._v(" "), _c('td', [_vm._v("Sexo")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(venda.arrematante.pessoa.pfSexo === 1 ? 'M' : 'F'))])]) : _vm._e(), _vm._v(" "), (venda.arrematante.pessoa.tipo === 1) ? _c('tr', [_c('td', [_vm._v("CPF")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [(venda.arrematante.pessoa.pfCpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(venda.arrematante.pessoa.pfCpf)))]) : _c('span', [_vm._v("SEM CPF")])]), _vm._v(" "), _c('td', [_vm._v("RG")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(venda.arrematante.pessoa.pfRg) + " " + _vm._s(venda.arrematante.pessoa.pfRgOrgaoEmissor) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (venda.arrematante.pessoa.tipo === 1) ? _c('tr', [_c('td', [_vm._v("Data de Nascimento")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(venda.arrematante.pessoa.pfDataNascimento ?
      _vm.moment(venda.arrematante.pessoa.pfDataNascimento.date).format('L') : '-') + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("Estado Civil")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(venda.arrematante.pessoa.pfEstadoCivilString))])]) : _vm._e(), _vm._v(" "), (venda.arrematante.pessoa.tipo === 1 && (venda.arrematante.pessoa.pfFiliacaoNomePai || venda.arrematante.pessoa.pfFiliacaoNomeMae)) ? _c('tr', [_c('td', [_vm._v("Nome do Pai")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(venda.arrematante.pessoa.pfFiliacaoNomePai))]), _vm._v(" "), _c('td', [_vm._v("Nome da Mãe")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(venda.arrematante.pessoa.pfFiliacaoNomeMae))])]) : _vm._e(), _vm._v(" "), (venda.arrematante.pessoa.tipo === 2) ? _c('tr', [_c('td', [_vm._v("Razão Social")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(venda.arrematante.pessoa.pjRazaoSocial ||
      venda.arrematante.pessoa.nome) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("Nome Fantasia")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(venda.arrematante.pessoa.pjNomeFantasia))])]) : _vm._e(), _vm._v(" "), (venda.arrematante.pessoa.tipo === 2) ? _c('tr', [_c('td', [_vm._v("CNPJ")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(venda.arrematante.pessoa.pjCnpj))]), _vm._v(" "), _c('td', [_vm._v("Inscrição Estadual")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(venda.arrematante.pessoa.pjInscricaoEstadual))])]) : _vm._e(), _vm._v(" "), (venda.arrematante.pessoa.tipo === 2) ? _c('tr', [_c('td', [_vm._v("Responsável")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(venda.arrematante.pjProprietarioNome))]), _vm._v(" "), _c('td', [_vm._v("CPF")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [(venda.arrematante.pjProprietarioCpf) ? _c('span', [_vm._v(_vm._s(_vm._f("formataCpf")(venda.arrematante.pjProprietarioCpf)))]) : _c('span', [_vm._v("SEM CPF DO RESPONSÁVEL")])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("IP Cadastro")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(venda.arrematante.pessoa.ipCadastro))]), _vm._v(" "), _c('td', [_vm._v("Observação")]), _vm._v(" "), _c('td', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(venda.arrematante.pessoa.observacao))])])])]), _vm._v(" "), _c('div', {
      staticClass: "tab-border no-border-top"
    }, [_c('table', {
      staticClass: "w-full table-arremate"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                      Endereço\n                    ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                      Cidade\n                    ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                      UF\n                    ")])])]), _vm._v(" "), _c('tbody', _vm._l((venda.arrematante.pessoa.enderecos), function(endereco) {
      return _c('tr', [_c('td', [_vm._v("\n                      " + _vm._s(endereco.logradouro) + ", " + _vm._s(endereco.numero) + " " + _vm._s(endereco.complemento) + ", " + _vm._s(endereco.bairro) + ", " + _vm._s(_vm._f("formataCep")(endereco.cep)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(endereco.municipio && endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros) + "\n                    ")])])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "tab-border no-border-top"
    }, [_c('table', {
      staticClass: "w-full table-arremate"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                      Email\n                    ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                      Finalidade\n                    ")])])]), _vm._v(" "), _c('tbody', _vm._l((venda.arrematante.pessoa.emails), function(email) {
      return _c('tr', [_c('td', [_vm._v("\n                      " + _vm._s(email.email) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(email.finalidade ? email.finalidade.nome : '-') + "\n                    ")])])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "tab-border no-border-top"
    }, [_c('table', {
      staticClass: "w-full table-arremate"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                      Telefone\n                    ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                      Finalidade\n                    ")])])]), _vm._v(" "), _c('tbody', _vm._l((venda.arrematante.pessoa.telefones), function(telefone) {
      return _c('tr', [_c('td', [_vm._v("\n                      " + _vm._s(_vm._f("formataTelefone")(telefone.telefone)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(telefone.finalidade ? telefone.finalidade.nome : '-') + "\n                    ")])])
    }), 0)])])]), _vm._v(" "), _c('div', {
      staticClass: "tab-border m-t-lg"
    }, [_c('table', {
      staticClass: "w-full table-arremate"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticStyle: {
        "width": "40px",
        "max-width": "40px",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                    Lote\n                  ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "30%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                    Descrição\n                  ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                    Valor Arremate\n                  ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                    Mínimo\n                  ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                    Com&Taxas\n                  ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                    Total\n                  ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "18%",
        "white-space": "nowrap"
      }
    }, [_vm._v("\n                    Situação\n                  ")])])]), _vm._v(" "), _c('tbody', _vm._l((venda.vendas), function(lote) {
      return _c('tr', {
        key: lote.id,
        staticClass: "list",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_c('td', {
        staticStyle: {
          "font-size": "15px"
        }
      }, [_vm._v("\n                    " + _vm._s(lote.numero) + "\n                  ")]), _vm._v(" "), _c('td', {
        staticStyle: {
          "font-size": "10px",
          "line-height": "1"
        }
      }, [_vm._v("\n                    " + _vm._s(lote.titulo) + "\n                  ")]), _vm._v(" "), _c('td', {
        staticStyle: {
          "white-space": "nowrap"
        }
      }, [_vm._v("\n                    R$" + _vm._s(_vm._f("moeda")(lote.valorArremate)) + "\n                  ")]), _vm._v(" "), _c('td', {
        staticStyle: {
          "white-space": "nowrap"
        }
      }, [_vm._v("\n                    R$" + _vm._s(_vm._f("moeda")(lote.valorMinimo)) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("R$" + _vm._s(_vm._f("moeda")((Number(lote.comissaoValor) + Number(lote.taxa)))))]), _vm._v(" "), _c('td', [_vm._v("R$" + _vm._s(_vm._f("moeda")(lote.total)))]), _vm._v(" "), _c('td', [_c('strong', {
        class: 'text-' + _vm.Status.Status[lote.status].class
      }, [_vm._v(_vm._s(_vm.Status.Status[lote.status].titulo))])])])
    }), 0)])])])]), _vm._v(" "), _c('div', {
      staticClass: "p-page-numer visible-print"
    }, [_vm._v("Página " + _vm._s(key + 1) + " de " + _vm._s(_vm.vendas && _vm.vendas.length))])])
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2202bb18","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/RelatorioSaidaArrematante.vue
// module id = 731
// module chunks = 2